import React, { useState } from "react";
import { TextField, Grid, CircularProgress } from "@mui/material";
import Lottie from "lottie-react";
import lottie from "../../Assets/Media/LottiesJSONs/Contact.json";
import useMediaQuery from "@mui/material/useMediaQuery";
import { post } from "../../utils/api";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    subject: "",
    message: "",
  });

  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const changeHandler = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    const { firstname, lastname, email, subject, message } = formData;

    // Simple form validation
    let formValid = true;
    let errorObj = {};

    if (!firstname) {
      errorObj.firstname = "First name is required";
      formValid = false;
    }
    if (!lastname) {
      errorObj.lastname = "Last name is required";
      formValid = false;
    }
    if (!email) {
      errorObj.email = "Email is required";
      formValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      errorObj.email = "Invalid email address";
      formValid = false;
    }
    if (!subject) {
      errorObj.subject = "Subject is required";
      formValid = false;
    }
    if (!message) {
      errorObj.message = "Message is required";
      formValid = false;
    }

    // Update error state
    setError(errorObj);

    // If the form is valid, proceed with the submission
    if (formValid) {
      setLoading(true);
      post("/help/send-message", {
        firstname,
        lastname,
        email,
        subject,
        message,
      })
        .then((response) => {
          if (response.message) {
            setFormData({
              firstname: "",
              lastname: "",
              email: "",
              subject: "",
              message: "",
            }); // Reset the form
            handleConfettiClick(); // Show success modal or confetti
          } else {
            alert("Error sending message, please try again.");
          }
        })
        .catch((error) => {
          alert("Error sending message, please try again.");
        })
        .finally(() => {
          setLoading(false); // Stop the loading animation after request completion
        });
    }
  };
  const handleConfettiClick = () => {
    document.getElementById("my_modal_3").showModal();
  };

  return (
    <div>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={6} pt={2}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="First Name"
            name="firstname"
            value={formData.firstname}
            onChange={changeHandler}
            error={!!error.firstname}
            helperText={error.firstname}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Last Name"
            name="lastname"
            value={formData.lastname}
            onChange={changeHandler}
            error={!!error.lastname}
            helperText={error.lastname}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Email"
            name="email"
            value={formData.email}
            onChange={changeHandler}
            error={!!error.email}
            helperText={error.email}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Subject"
            name="subject"
            value={formData.subject}
            onChange={changeHandler}
            error={!!error.subject}
            helperText={error.subject}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Message"
            name="message"
            value={formData.message}
            onChange={changeHandler}
            error={!!error.message}
            helperText={error.message}
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <button
            type="submit"
            color="primary"
            style={{ width: "100%", position: "relative" }}
            className="join-btn custom-btn main-button w-full"
            onClick={submitHandler}
          >
            {loading ? (
              <CircularProgress
                size={24}
                style={{
                  color: "black",
                }}
              />
            ) : (
              "Send Message"
            )}
          </button>
        </Grid>
      </Grid>
      <dialog id="my_modal_3" className="modal text-center">
        <div
          className="modal-box modal-box-graident-border text-center"
          style={{ overflow: "hidden" }}
        >
          <div className="main-bg p-[20px]  rounded-[12px]">
            <form method="dialog">
              <button className="btn btn-sm btn-circle btn-ghost absolute justify-right top-2 right-2">
                ✕
              </button>
            </form>
            <h1 className="font-bold text-pent2 !text-[36px]">We Heard You!</h1>

            <Lottie
              animationData={lottie}
              loop
              autoplay
              style={{
                width: isMobile ? "200px" : "400px",
                height: isMobile ? "200px" : "400px",
                background: "transparent",
                scale: 5,
                margin: "auto",
              }}
            />
            <p className=" !text-[black] !text-[20px]">
              Thank you for reaching out! We&apos;ll get back to you.
            </p>
          </div>
        </div>
      </dialog>
    </div>
  );
};

export default ContactForm;
